import {
	CollectionModelImageVisibility,
	CollectionModelImageVisibilityMutator,
	type ModelStateImageVisibility,
} from './imageVisibility';

export interface ModelStateHiddenImageVisibility extends ModelStateImageVisibility {
	tag: 'hidden';
	hidden: boolean;
}

export class CollectionModelHiddenImageVisibilityMutator extends CollectionModelImageVisibilityMutator<CollectionModelHiddenImageVisibility> {
	constructor(imageVisibility: CollectionModelHiddenImageVisibility) {
		super(imageVisibility);
	}

	init(hidden: boolean) {
		this.imageVisibility.imageVisibilityState.Mutator.create('hidden');
		this.setHidden(hidden);
	}

	setHidden(hidden: boolean) {
		const state = this.getValue();
		state.hidden = hidden;
		this.setValue(state);
	}
}

export class CollectionModelHiddenImageVisibility extends CollectionModelImageVisibility<ModelStateHiddenImageVisibility> {
	static state(id: string): ModelStateHiddenImageVisibility {
		return {
			id,
			tag: 'hidden',
			hidden: false,
		};
	}

	static readonly TAG = 'hidden' as const;
	readonly tag = CollectionModelHiddenImageVisibility.TAG;
	override Mutator = new CollectionModelHiddenImageVisibilityMutator(this);

	static isHidden(t: CollectionModelImageVisibility): t is CollectionModelHiddenImageVisibility {
		return t?.tag === CollectionModelHiddenImageVisibility.TAG;
	}

	get hidden(): boolean {
		const state = this.state;
		if (!state) {
			return false;
		}
		return state.hidden;
	}
}
